var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.553 7.81 5.168.083c-.172-.18-.466-.053-.466.203v6.495L2.466 4.444C2.294 4.265 2 4.392 2 4.647v6.708c0 .423.16.829.447 1.13l2.91 3.047a1.5 1.5 0 0 0 1.08.468h2.129a1.5 1.5 0 0 0 1.08-.468l2.909-3.047c.285-.299.445-.705.445-1.13V8.94a1.655 1.655 0 0 0-.447-1.13z",
    fill: "#FA005A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.471 10.634a.484.484 0 0 1-.135.337l-2.394 2.464a.457.457 0 0 1-.662 0l-2.387-2.464a.486.486 0 0 1-.138-.337v-.938a.49.49 0 0 1 .138-.34l.86-.88a.461.461 0 0 1 .66 0l1.203 1.231 1.2-1.232a.461.461 0 0 1 .66 0l.86.881a.485.485 0 0 1 .138.34v.938h-.003z",
    fill: "#FFC500"
  })));
};

export default SvgLogo;